import React from "react";
import { Link } from "react-router-dom";
import InnerHero from "../../../components/InnerHero";
import {
  ArrowLeft,
  Beaker,
  Cpu,
  Database,
  Images,
  Monitor,
} from "lucide-react";

const PGFacilitiesPage = ({
  title,
  shortTitle,
  programmePath,
  programmeLabel,
  heroImage,
  images,
  facilities,
  facts,
}) => (
  <main>
    <InnerHero
      title={title}
      image={heroImage}
      breadcrumbs={[
        { label: "Academics", to: "/academics" },
        { label: programmeLabel, to: programmePath },
        { label: "Facilities" },
      ]}
    />

    <section className="bg-surface-alt/60 border-b border-brand/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-3 text-xs font-sans-ui font-semibold tracking-wider text-brand">
        <Link
          to={programmePath}
          className="inline-flex items-center gap-2 uppercase hover:underline"
        >
          <ArrowLeft size={14} />
          Back to {shortTitle}
        </Link>
      </div>
    </section>

    <section className="max-w-7xl mx-auto px-6 lg:px-10 py-12">
      <div className="grid lg:grid-cols-3 gap-10">
        <div className="lg:col-span-2 space-y-10">
          <section>
            <div className="flex items-end justify-between gap-4 mb-5">
              <div>
                <h2
                  className="text-2xl md:text-3xl text-brand font-semibold flex items-center gap-2"
                  style={{ fontFamily: "'Cormorant Garamond', serif" }}
                >
                  <Images size={22} />
                  Facilities Gallery
                </h2>

                <p className="text-sm text-[#3a3a3a]/80 italic mt-1">
                  The research lab is well equipped with licensed software tools and as well as opensource software tools with necessary hardware platforms listed below.                </p>
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-4">
              {images.map((image) => (
                <figure
                  key={image.src}
                  className="bg-white border border-brand/15 overflow-hidden"
                >
                  <div className="aspect-[16/10] overflow-hidden">
                    <img
                      src={image.src}
                      alt={image.alt || image.title}
                      className="w-full h-full object-contain bg-white"
                      loading="lazy"
                    />
                  </div>

                  {/* <figcaption className="px-4 py-3">
                    <span className="text-xs uppercase tracking-widest text-brand font-semibold font-sans-ui">
                      {image.title}
                    </span>
                  </figcaption> */}
                </figure>
              ))}
            </div>
          </section>

          <section>
            <h2
              className="text-2xl md:text-3xl text-brand font-semibold flex items-center gap-2 mb-5"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              <Monitor size={22} />
              Facilities
            </h2>

            <div className="bg-white border border-brand/15 p-5">
              <ul className="grid md:grid-cols-2 gap-x-6 gap-y-2 pl-5 list-disc text-sm text-[#2a2a2a]/85 leading-relaxed">
                {facilities.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
          </section>
        </div>

        <aside className="space-y-5">
          <div className="bg-white border border-brand/15 p-5 lg:sticky lg:top-36 self-start">
            <h4 className="text-xs uppercase tracking-widest text-brand font-semibold">
              Facilities Facts
            </h4>

            <div className="mt-3 space-y-3 text-sm">
              {facts.map(([label, value], index) => (
                <div key={label} className="flex items-center gap-2">
                  {index === 0 ? (
                    <Cpu size={14} className="text-brand" />
                  ) : (
                    <Beaker size={14} className="text-brand" />
                  )}
                  <span>
                    {label}: <strong>{value}</strong>
                  </span>
                </div>
              ))}
            </div>

            <Link
              to={programmePath}
              className="block mt-5 text-center bg-brand text-surface py-2.5 text-sm font-semibold hover:bg-brand-dark transition"
            >
              Programme Overview
            </Link>

            <div className="mt-6 pt-5 border-t border-brand/10">
              <h4 className="text-xs uppercase tracking-widest text-brand font-semibold mb-3">
                Key Resources
              </h4>

              <ul className="space-y-1.5 text-sm text-[#2a2a2a]">
                {facilities.slice(0, 6).map((item) => (
                  <li key={item} className="flex items-center gap-1">
                    <Database size={12} className="text-brand" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </aside>
      </div>
    </section>
  </main>
);

export default PGFacilitiesPage;
